module.exports = __webpack_public_path__ + "img/bg_mandala_03.47c5a5f0.jpg";